import { gsap } from 'gsap'
import { ajaxIntoModal } from '../helpers/ajax.js'
import { openModal } from './modal.js'
import { workModalInit } from './work-modal.js'

const registerWorkCardEventListeners = () => {
    document.querySelectorAll('[data-work-card]').forEach((workCard) => {
        const info = workCard.querySelector('[data-info]')
        const services = workCard.querySelector('[data-services]')
        const servicesHeight = services.clientHeight

        workCard.addEventListener('mouseenter', () => {
            gsap.to(info, {
                y: servicesHeight + 20,
                duration: 0.6,
                ease: 'power1.inOut'
            })
        })

        workCard.addEventListener('mouseleave', () => {
            gsap.to(info, {
                y: 0,
                duration: 0.6,
                ease: 'power1.inOut'
            })
        })

        workCard.addEventListener('click', async () => {
            await ajaxIntoModal(workCard.dataset.url)
            openModal()
            workModalInit()
        })
    })

    document.querySelectorAll('[data-work-card] a').forEach((link) => {
        link.addEventListener('click', (event) => event.preventDefault())
    })
}

// Re-register work card event listeners after sprig re-renders
htmx.on('htmx:afterSwap', function (event) {
    registerWorkCardEventListeners()
})

// Register Work card event listeners on initial page load
registerWorkCardEventListeners()
